<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Manage Charging Station / <span class="ion-sub-title">{{stationId}}</span> </ion-title>
          <ion-buttons v-slot: end v-if="viewmode && rightToUpdate">
          <!-- <ion-button @click="viewInstallations" v-if="!viewInstallationsInd">
              View Installations
          </ion-button> -->
          <ion-button @click="editStation" class="hdrBtn">
            EDIT
          </ion-button>
        </ion-buttons>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ChargingStationDetail v-if="!viewmode" />
      <ChargingStationView v-if="viewmode" />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ChargingStationDetail from "@/components/admin/ChargingStationDetail.vue";
import ChargingStationView from "@/components/admin/ChargingStationView.vue";
import { AppUtils } from "@/util/app-utils";
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
  name:  'chargingStationDetail',
  components: {
    ChargingStationDetail, ChargingStationView, IonHeader, IonToolbar, IonButton, IonButtons, IonBackButton, IonTitle, IonContent
  },
  data() {
    return {
      rightToUpdate: false,
      viewmode: false,
      stationId: "New",
      viewInstallationsInd: false
    }
  },
  async mounted() {
    let userRole = localStorage.getItem("user.roleId")
    // if(userRole != 4) {
    //   this.rightToUpdate = new AppUtils().getUserAccess("40|U");
    //   this.viewInstallationsInd = true;
    // } else {
    //   this.viewInstallationsInd = false;
    //   this.rightToUpdate = new AppUtils().getUserAccess("110|U");
    //   var branchStationInfo = JSON.parse(localStorage.getItem('branchStationInfo'));
    //   let currentDate = new Date();
    //   let lastEffectiveDate = new Date(branchStationInfo.stationBranchLasteffectiveDate);
    //   if(branchStationInfo.stationBranchStatus.code == "A" && (currentDate < lastEffectiveDate)) {
    //     this.rightToUpdate = true;
    //   } else {
    //     this.rightToUpdate = false;
    //   }
      
    // }
    if (this.$route.params.stationId) {
      if (this.$route.query.mode) {
        this.viewmode = false;
        this.stationId = "Edit";
      } else {
        this.viewmode = true;
        
        if(userRole != 4  && userRole != 3 && userRole !=5) {
          this.rightToUpdate = true;
        } else {
          this.rightToUpdate = false;
        }

        this.stationId = "Detail";
      }
    }
    
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    editStation() {
      this.viewmode = false;
      this.stationId = "Edit";
    },
    viewInstallations() {
      this.$router.push("/admin/chargerinstallations");
    }
  }
})
</script>
